/* Manual product browsing: native swiping, desktop dragging and arrow keys. */
(() => {
  const instances = new Map();
  const init = () => document.querySelectorAll('[data-mc-carousel]').forEach(root => {
    if (instances.has(root)) return;
    const track = root.querySelector('.mc-carousel-track');
    if (!track) return;
    const cleanups = [];
    let pointer = null, dragging = false, suppressClick = false;
    const listen = (node, name, fn, options) => { node.addEventListener(name, fn, options); cleanups.push(() => node.removeEventListener(name, fn, options)); };
    listen(track, 'pointerdown', event => {
      if (event.button !== 0 && event.pointerType === 'mouse') return;
      suppressClick = false;
      if (event.target.closest('button,input,select,textarea')) return;
      pointer = {id:event.pointerId, type:event.pointerType, x:event.clientX, left:track.scrollLeft};
    });
    listen(window, 'pointermove', event => {
      if (!pointer || event.pointerId !== pointer.id || pointer.type !== 'mouse') return;
      const delta = event.clientX - pointer.x;
      if (!dragging && Math.abs(delta) < 6) return;
      dragging = true; suppressClick = true; track.classList.add('mc-is-dragging');
      event.preventDefault(); track.scrollLeft = pointer.left - delta;
    }, {passive:false});
    const release = event => {
      if (!pointer || event.pointerId !== pointer.id) return;
      pointer = null; dragging = false; track.classList.remove('mc-is-dragging');
    };
    listen(window, 'pointerup', release); listen(window, 'pointercancel', release);
    listen(track, 'dragstart', event => event.preventDefault());
    listen(track, 'click', event => { if (suppressClick) { event.preventDefault(); event.stopImmediatePropagation(); suppressClick = false; } }, true);
    listen(track, 'keydown', event => {
      if (event.target !== track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const card = track.querySelector('.mc-product-card');
      const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth / 2;
      track.scrollLeft = event.key === 'Home' ? 0 : event.key === 'End' ? track.scrollWidth - track.clientWidth : track.scrollLeft + (event.key === 'ArrowRight' ? step : -step);
    });
    listen(window, 'blur', () => { pointer = null; dragging = false; track.classList.remove('mc-is-dragging'); });
    instances.set(root, {destroy:() => cleanups.forEach(fn => fn())});
  });
  document.addEventListener('mc:home-rotated', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => { instances.forEach((instance, root) => { if (event.target.contains(root)) { instance.destroy(); instances.delete(root); } }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();